import Vue from 'vue'
import Vuex from 'vuex'

import * as auth from './modules/auth'
import * as resursi from './modules/resursi'
import * as placanje from './modules/placanje'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    perPage: 5,
    //page: 1,
    filters: {
      datum_od: '2020-01-01',
      datum_do: '2020-12-01'
    }
    // korpa: [
    //   {
    //     redni_broj: 1,
    //     broj_tablica: 'PN111222',
    //     tip_kartte: 'DK06',
    //     primalac: '',
    //     jedinicna_cena: 1000.0,
    //     kolicina: 1,
    //     cena: 1000.0,
    //     uplatilac: '',
    //     broj_racuna: '',
    //     svrha_uplate: '',
    //     poziv_na_broj: '',
    //     datum_od: new Date(),
    //     datum_do: new Date()
    //   },
    //   {
    //     redni_broj: 2,
    //     broj_tablica: 'PN111222',
    //     tip_kartte: 'PK01',
    //     primalac: '',
    //     jedinicna_cena: 100.0,
    //     kolicina: 1,
    //     cena: 100.0,
    //     uplatilac: '',
    //     broj_racuna: '',
    //     svrha_uplate: '',
    //     poziv_na_broj: '',
    //     datum_od: new Date(),
    //     datum_do: new Date()
    //   }
    // ],
    // cenovnik: []
  },
  mutations: {},
  actions: {},
  modules: {
    auth,
    resursi,
    placanje
  }
})
